module.exports = __webpack_public_path__ + "img/image (30).15cff844.jpg";